import { stripDomain } from '@hotjar/webapp/utils/urls';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import type { TrackingDownloadArgs } from './types';
import { validateEventData } from './validate-event-data';
import * as hotjarTracking from './tools/hotjar';

/**
 * Track when something was downloaded.
 */
export const download = ({
  item,
  fileType,
  groupData,
  data,
}: TrackingDownloadArgs): Promise<void> => {
  const valid = validateEventData('Track.downloadItem', [item, fileType]);

  if (valid) {
    const url = stripDomain(window.location.href);
    const trackData = {
      item,
      file_type: fileType,
      url_event_was_triggered_on: url, // we add the url_event_was_triggered_on as current page url in case it is not defined in the groupData
      ...groupData,
      ...data,
    };

    hotjarTracking.tagRecording(`Item Downloaded: ${item}`);
    return Segment.track('Item Downloaded', trackData);
  }

  return Promise.resolve();
};
